export const SET_CURRENCY_CONVERSION_TABLE = 'SET_CURRENCY_CONVERSION_TABLE';
export const SET_VISITOR_CURRENCY = 'SET_VISITOR_CURRENCY';
export const SET_EXCHANGE_RATE_MARGIN = 'SET_EXCHANGE_RATE_MARGIN';